import { useEffect, useRef, useState } from "react";
import * as d3 from "d3";
import useWindowDimensions from "../utils/useWindoeDimensions";


export const BarChart = ({ barGraph, height, data, barKey }) => {
  const { width: windowWidth } = useWindowDimensions();
  const MARGIN = { top: 30, right: windowWidth < 768 ? 0 : 30, bottom: 50, left: windowWidth < 768 ? 30 : 50 };

  // bounds = area inside the graph axis = calculated by substracting the margins
  const axesRef = useRef(null);
  // const boundsWidth = width - MARGIN.right - MARGIN.left;

  const [rectangles, setRectangles] = useState(null);

  const [width, setWidth] = useState(null);

  useEffect(() => {
    if (!barGraph || !barGraph.current) return;

    setWidth(
      barGraph.current.offsetWidth > 0
        ? barGraph.current.offsetWidth - 80
        : null
    );
  }, [barGraph, data]);
  const boundsHeight = height - MARGIN.top - MARGIN.bottom;
  useEffect(() => {
    if (!width) return;

    if (!rectangles && data && height !== 0) {
      const allGroups = data.map((d) => String(d.x));
      const allSubgroups = [barKey + "_neg", barKey + "_neu", barKey + "_pos"];
      // Data Wrangling: stack the data
      const stackSeries = d3
        .stack()
        .keys(allSubgroups)
        .order(d3.stackOrderNone);
      //.offset(d3.stackOffsetNone);
      const series = stackSeries(data);

      // Color Scale
      var colorScale = d3
        .scaleOrdinal()
        .domain(allGroups)
        .range(["#9ECA7E", "#305EA9", "#1C97C9"]);

      // Y axis
      const max = 100; // todo

      const yScale = d3
        .scaleLinear()
        .domain([0, max || 0])
        .range([boundsHeight, 0]);
      // X axis
      const xScale = d3
        .scaleBand()
        .domain(allGroups)
        .range([0, width - MARGIN.right - MARGIN.left])

        .padding(0.5);

      const rects = series.map((subgroup, i) => {
        return (
          <g key={i}>
            {subgroup.map((group, j) => {
              return (
                <g key={`${i}-${j}`}>
                  <rect
                    key={j}
                    ikey={i}
                    jkey={j}
                    clip-path={i === 2 ? `url(#round-corner${i}-${j})` : ""}
                    x={xScale(group.data.x)}
                    y={yScale(group[1])}
                    height={yScale(group[0]) - yScale(group[1])}
                    width={xScale.bandwidth()}
                    fill={colorScale(subgroup.key)}
                    opacity={1}
                  ></rect>
                  <clipPath id={`round-corner${i}-${j}`}>
                    <rect
                      className="nope"
                      x={xScale(group.data.x)}
                      y={0}
                      width={xScale.bandwidth()}
                      height={1000}
                      rx="25"
                      ry="10"
                    />
                  </clipPath>
                </g>
              );
            })}
          </g>
        );
      });

      setRectangles(rects);

      const svgElement = d3.select(axesRef.current);
      svgElement.selectAll("*").remove();
      const xAxisGenerator = d3
        .axisBottom(xScale)
        .tickValues(
          allGroups.map((elm, index) => windowWidth < 768 ? (index % 4 === 0 ? elm : "") : (index % 2 === 0 ? elm : ""))
        );
      svgElement
        .append("g")
        .attr("id", "x-axis")
        .attr("transform", "translate(0," + boundsHeight + ")")
        .call(xAxisGenerator);

      const yAxisGenerator = d3.axisLeft(yScale).tickFormat(
        x => x + "%"
      );
      svgElement.append("g")
      .attr("transform", "translate(10,0)")
      .call(yAxisGenerator);

      svgElement.selectAll("text").attr("fill", "#818181");
    } else {
      // const allGroups = data.map((d) => String(d.x));
      const allSubgroups = [barKey + "_neg", barKey + "_neu", barKey + "_pos"];

      // Data Wrangling: stack the data
      const stackSeries = d3
        .stack()
        .keys(allSubgroups)
        .order(d3.stackOrderNone);
      //.offset(d3.stackOffsetNone);
      const series = stackSeries(data);

      // Color Scale

      // Y axis
      const max = 100; // todo

      const yScale = d3
        .scaleLinear()
        .domain([0, max || 0])
        .range([boundsHeight, 0]);

      d3.selectAll("rect:not(.nope)").each(function (rect, j) {
        const thisRect = d3.select(this);

        const key = thisRect.attr("ikey");
        const subkey = thisRect.attr("jkey");
        const group = series[key][subkey];

        thisRect
          .transition()
          .attr("y", yScale(group[1]))
          .attr("height", yScale(group[0]) - yScale(group[1]));

        d3.select(`#round-corner${key}-${subkey} rect`)
          .transition()
          .attr("y", yScale(group[1]));
      });
    }
  }, [data, barKey, width, height, rectangles, windowWidth,MARGIN.right,MARGIN.left, boundsHeight]);

  return (
    <div>
      <svg width={width} height={height}>
        <g
          width={width - MARGIN.right - MARGIN.left}
          height={boundsHeight}
          transform={`translate(${[MARGIN.left, MARGIN.top].join(",")})`}
        >
          {rectangles}
        </g>
        <g
          width={width - MARGIN.right - MARGIN.left}
          height={boundsHeight}
          ref={axesRef}
          transform={`translate(${[MARGIN.left, MARGIN.top].join(",")})`}
        />
      </svg>
    </div>
  );
};
